import React, { useState, useCallback, useEffect } from 'react';
import VehicleSelect from './VehicleSelect';
import AddVehicle from './AddVehicle';

const ReplaceVehicle = (props) => {
	const { policy, onCancel, save, onSave } = props;
	const [vehicle, setVehicle] = useState(null);

	useEffect(() => {
		if (save && save.previousVehicle) {
			setVehicle(save.previousVehicle);
		}
	}, [save]);

	const _onSave = useCallback(
		async (vehicleData, _rate) => {
			vehicleData.previousVehicle = vehicle;
			await onSave(vehicleData, _rate);
		},
		[onSave, vehicle]
	);

	if (!vehicle) return <VehicleSelect onVehicleSelect={setVehicle} policy={policy} onCancel={onCancel} message='Please select the vehicle you would like to replace' />;

	return <AddVehicle {...props} onSave={_onSave} previousVehicle={vehicle} />;
};

export default ReplaceVehicle;
